(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-video-box"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    var mobileQuery = window.matchMedia('(max-width: 768px)');

    document.querySelectorAll('.custom-video-box').forEach(function (box) {
      var videoWrapper = box.querySelector('#customVideoBox .wrapper');
      var sliderEl = box.querySelector('.video-slider');
      if (!sliderEl) return;

      var thumbnails = box.querySelectorAll('.thumbnail[data-src-desktop]');

      function updateVideoSources() {
        thumbnails.forEach(function (link) {
          var src = (mobileQuery.matches && link.dataset.srcMobile)
            ? link.dataset.srcMobile
            : link.dataset.srcDesktop;

          link.href = src;
        });
      }

      updateVideoSources();
      mobileQuery.addEventListener('change', updateVideoSources);

      new Swiper(sliderEl, {
        slidesPerView: 1.15,
        spaceBetween: 16,
        navigation: {
          nextEl: videoWrapper.querySelector('.swiper-button-next'),
          prevEl: videoWrapper.querySelector('.swiper-button-prev'),
        },
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
